// extracted by mini-css-extract-plugin
export default {"wrapper":"tk","form":"uk","preference":"vk","request":"wk","job":"xk","smallprint":"yk","asterisk":"zk","success":"Ak","circle":"Bk"};